(function () {
	if (window.__kcCartReady) return;
	window.__kcCartReady = true;

	var root = document.querySelector('[data-kc-cart]');
	if (!root) return;

	var lastTrigger = null;
	var stockWarningTimers = {};

	function isOpen() {
		return root.classList.contains('is-open');
	}

	function focusableElements() {
		return Array.prototype.slice.call(
			root.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])')
		).filter(function (el) {
			return el.offsetParent !== null;
		});
	}

	function onKeydown(event) {
		if (!isOpen()) return;
		if (event.key === 'Escape') {
			event.preventDefault();
			closeDrawer();
			return;
		}
		if (event.key === 'Tab') {
			var focusable = focusableElements();
			if (!focusable.length) return;
			var first = focusable[0];
			var last = focusable[focusable.length - 1];
			if (event.shiftKey && document.activeElement === first) {
				event.preventDefault();
				last.focus();
			} else if (!event.shiftKey && document.activeElement === last) {
				event.preventDefault();
				first.focus();
			}
		}
	}

	function openDrawer(trigger) {
		if (trigger) lastTrigger = trigger;
		root.hidden = false;
		// Force layout so the transform transition runs from its start value.
		root.offsetHeight;
		root.classList.add('is-open');
		document.body.style.overflow = 'hidden';
		document.addEventListener('keydown', onKeydown);
		var closeButton = root.querySelector('[data-kc-cart-close]');
		if (closeButton) closeButton.focus();
		if (trigger) trigger.setAttribute('aria-expanded', 'true');
	}

	function closeDrawer() {
		root.classList.remove('is-open');
		document.body.style.overflow = '';
		document.removeEventListener('keydown', onKeydown);
		window.setTimeout(function () {
			if (!isOpen()) root.hidden = true;
		}, 300);
		if (lastTrigger) {
			lastTrigger.setAttribute('aria-expanded', 'false');
			lastTrigger.focus();
		}
	}

	function syncHeaderCount(count) {
		document.querySelectorAll('.js-header-cart-item-count').forEach(function (el) {
			el.textContent = count > 99 ? '99+' : count;
		});
		document.querySelectorAll('.header__cart-count').forEach(function (el) {
			el.setAttribute('data-cart-count', count);
		});
	}

	function sectionUrl() {
		var url = window.location.pathname + window.location.search;
		var separator = url.indexOf('?') > -1 ? '&' : '?';
		return url + separator + 'section_id=kc-cart-drawer';
	}

	function refresh(keepOpen) {
		return fetch(sectionUrl())
			.then(function (response) {
				return response.text();
			})
			.then(function (html) {
				var doc = new DOMParser().parseFromString(html, 'text/html');
				var newRoot = doc.querySelector('[data-kc-cart]');
				if (!newRoot) return;

				var wasOpen = keepOpen && isOpen();
				newRoot.hidden = true;
				root.replaceWith(newRoot);
				root = newRoot;
				bind(root);

				var countEl = root.querySelector('[data-kc-cart-count]');
				if (countEl) syncHeaderCount(countEl.textContent.trim());

				if (wasOpen) openDrawer();
			});
	}

	function performChange(stepper, quantity) {
		var item = stepper.closest('[data-kc-cart-item]');
		var key = stepper.getAttribute('data-key');
		if (item) item.classList.add('is-loading');

		fetch('/cart/change.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ id: key, quantity: quantity })
		})
			.then(function () {
				return refresh(true);
			})
			.catch(function () {
				if (item) item.classList.remove('is-loading');
			});
	}

	function showStockWarning(stepper, max) {
		var item = stepper.closest('[data-kc-cart-item]');
		var warning = item ? item.querySelector('[data-kc-cart-stock-warning]') : null;
		if (!warning) return;
		var template = warning.getAttribute('data-template') || ((window.KC_I18N && KC_I18N.stockLimit) || 'Only {n} in stock');
		warning.textContent = template.replace('{n}', max);
		warning.hidden = false;

		var key = stepper.getAttribute('data-key');
		if (stockWarningTimers[key]) window.clearTimeout(stockWarningTimers[key]);
		stockWarningTimers[key] = window.setTimeout(function () {
			warning.hidden = true;
		}, 3000);
	}

	function bind(scope) {
		var overlay = scope.querySelector('[data-kc-cart-overlay]');
		if (overlay) overlay.addEventListener('click', closeDrawer);

		scope.querySelectorAll('[data-kc-cart-close]').forEach(function (button) {
			button.addEventListener('click', closeDrawer);
		});

		scope.querySelectorAll('[data-kc-cart-stepper]').forEach(function (stepper) {
			var quantity = parseInt(stepper.getAttribute('data-quantity'), 10) || 0;
			var management = stepper.getAttribute('data-inventory-management');
			var policy = stepper.getAttribute('data-inventory-policy');
			var inventory = parseInt(stepper.getAttribute('data-inventory'), 10);

			var decreaseButton = stepper.querySelector('[data-kc-cart-decrease]');
			var increaseButton = stepper.querySelector('[data-kc-cart-increase]');

			if (decreaseButton) {
				decreaseButton.addEventListener('click', function () {
					performChange(stepper, quantity - 1);
				});
			}

			if (increaseButton) {
				increaseButton.addEventListener('click', function () {
					var nextQuantity = quantity + 1;
					if (management === 'shopify' && policy === 'deny' && !isNaN(inventory) && nextQuantity > inventory) {
						showStockWarning(stepper, inventory);
						return;
					}
					performChange(stepper, nextQuantity);
				});
			}
		});

		scope.querySelectorAll('[data-kc-cart-remove]').forEach(function (button) {
			button.addEventListener('click', function () {
				var stepper = button
					.closest('[data-kc-cart-item]')
					.querySelector('[data-kc-cart-stepper]');
				performChange(stepper, 0);
			});
		});

		scope.querySelectorAll('[data-kc-cart-upsell-add]').forEach(function (button) {
			button.addEventListener('click', function (event) {
				event.preventDefault();
				if (button.disabled) return;
				var variantId = button.getAttribute('data-variant-id');
				if (!variantId) return;
				button.disabled = true;
				fetch('/cart/add.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
				})
					.then(function () {
						return refresh(true);
					})
					.catch(function () {
						button.disabled = false;
					});
			});
		});
	}

	function openFromTrigger(event) {
		event.preventDefault();
		var trigger = event.currentTarget;
		refresh(false).then(function () {
			openDrawer(trigger);
		});
	}

	document.querySelectorAll('[data-kc-cart-toggle]').forEach(function (trigger) {
		trigger.addEventListener('click', openFromTrigger);
	});

	document.addEventListener('kc:cart:added', function () {
		refresh(false).then(function () {
			openDrawer(document.querySelector('[data-kc-cart-toggle]'));
		});
	});

	bind(root);
})();
